export enum GalleryLayout5Theme {
  WHITE = 'WHITE',
  CREAM = 'CREAM',
}
